import React, { Component } from 'react'

class MapMarker extends Component{

  render(){
    if (this.props.type === 'address'){
      return(
        <div
        style={{
          position:'relative',
          width: '64px',
          boxShadow: '1px 5px 10px -2px #00000033',
          ...this.props.style
        }}>
        <img src='./icons/pin.png' style={{position:'absolute', left:'2px',width: '32px'}} alt='location'/>
        {this.props.text}
      </div>
      )
    }
    return (
        <img onClick={()=>this.props.selectLocation(this.props.selectKey)} src={this.props.rest.logo} style={{width: '48px'}} alt='location'/>
    );
  }
}

export default MapMarker;
